import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../../components/auth/ProtectedRoute';

const TradeShipments = lazy(() => import('./TradeShipments'));
const FreightBookings = lazy(() => import('./FreightBookings'));
const Containers = lazy(() => import('./Containers'));
const TradeCostingDashboard = lazy(() => import('./TradeCostingDashboard'));
const LettersOfCredit = lazy(() => import('./LettersOfCredit'));
const CustomsDeclarations = lazy(() => import('./CustomsDeclarations'));
const HSCodes = lazy(() => import('./HSCodes'));
const TradeCompliance = lazy(() => import('./TradeCompliance'));

export const tradeRoutes = (
    <React.Fragment key="trade">
        <Route element={<ProtectedRoute permission="trade.shipment.view" />}>
            <Route path="/trade/shipments" element={<TradeShipments />} />
            <Route path="/trade/freight-bookings" element={<FreightBookings />} />
            <Route path="/trade/containers" element={<Containers />} />
            <Route path="/trade/costing-dashboard" element={<TradeCostingDashboard />} />
        </Route>
        <Route element={<ProtectedRoute permission="trade.lc.view" />}>
            <Route path="/trade/letters-of-credit" element={<LettersOfCredit />} />
        </Route>
        <Route element={<ProtectedRoute permission="trade.customs.view" />}>
            <Route path="/trade/customs-declarations" element={<CustomsDeclarations />} />
        </Route>
        <Route element={<ProtectedRoute permission="trade.hs_code.view" />}>
            <Route path="/trade/hs-codes" element={<HSCodes />} />
        </Route>
        <Route element={<ProtectedRoute permission="trade.compliance.view" />}>
            <Route path="/trade/compliance" element={<TradeCompliance />} />
        </Route>
    </React.Fragment>
);
